import { HashRouter, Routes, Route } from 'react-router-dom';
import SustainabilityPage from './Views/SustainabilityPage/SustainabilityPage';
import ProductsPage from './Views/ProductsPage/ProductsPage';
import LandingPage from './Views/LandingPage/LandingPage';
import ProductPage from './Views/ProductPage/ProductPage';
import BrandsPage from './Views/BrandsPage/BrandsPage';
import AboutPage from './Views/AboutPage/AboutPage';
import './App.css';

function App() {
  return (
    <div className="App">
      <HashRouter>
        <Routes>
          <Route exact path='/' element={<LandingPage />} />
          <Route exact path='/about' element={<AboutPage />} />
          <Route exact path='/products' element={<ProductsPage />} />
          <Route exact path='/sustainability' element={<SustainabilityPage />} />
          <Route exact path='/product/:title' element={<ProductPage />} />
          <Route exact path='/brands' element={<BrandsPage />} />
        </Routes>
      </HashRouter>
    </div>
  );
}

export default App;
